<script lang="ts" setup>
import IconMessageBubble from '@lahaus-roomie/roomie/src/assets/icons/message-bubble.svg'
import type { Props } from './types'
withDefaults(defineProps<Props>(), {
  botPictureType: 'icon'
})
const { t } = useI18n()
</script>

<script lang="ts">
export default {
  name: 'AppChatBubbleAuthor'
}
</script>

<template>
  <span
    v-if="author === 'user'"
    class="app-chat__author-user-title">
    {{ t('you') }}
  </span>

  <div
    v-else
    class="app-chat__author-bot-title"
    :class="{ '!hidden': botPictureType === 'hidden' }">
    <div
      v-if="botPictureType === 'icon'"
      class="w-16 h-16 bg-primary-600 rounded-full grid place-content-center">
      <IconMessageBubble class="w-12 h-12 text-white" />
    </div>

    <img
      v-else
      src="https://lahaus.imgix.net/static/lh-landing/img-sam-profile.png?auto=compress,enhance,format"
      class="w-44 h-44 object-cover mr-4"
      alt="Sam">

    <span>
      {{ botName }}
    </span>
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
